import React from 'react';
import {LINKS} from "../../constants";

const Footer = () => {

    const links = LINKS;

    return (
      <footer>
        <div className="visible-s">
          <div className="f-s">
            <nav className="f-s__nav-menu">
              <div className="f-s__heading">
                <div className="f-s__nav-menu--logo" />
                <div
                    className="f-s__back-top"
                    role="button"
                    onClick={() => {
                      window.scrollTo({top: 0, behavior: 'smooth'});
                    }}
                >
                  <span className="f-s__back-top--img" />
                </div>
              </div>

              <div className="f-s__ql">
                <div className="f-s__ql-item">
                  <a className="f-s__ql-link" href={links.responsible_gambling}>Responsible Gambling</a>
                </div>
                <div className="f-s__ql-item">
                  <a className="f-s__ql-link" href={links.contact_us}>Contact us</a>
                </div>
                <div className="f-s__ql-item">
                  <a className="f-s__ql-link" href={links.help}>Help</a>
                </div>
                <div className="f-s__ql-item">
                  <a className="f-s__ql-link" href={links.terms_and_conditions}>T&C's</a>
                </div>
              </div>

              <div className="f-s__payments" />

              <div className="f-s__compliance">
                <a className="f-s__compliance-link" href={links.ndpb} target="_blank"></a>
              </div>
            </nav>
            <div className="f-s__copyright">
              <div className="f-s__copyright-item">
                <span>© Bet9ja all rights reserved</span>
              </div>
              <div className="f-s__copyright-item txt-r">
                <a className="txt-white d-ib"></a>
                <span className="icon-eighteen ml5" />
              </div>
            </div>
          </div>
        </div>

        <div className="hidden-s">
          <div className="container">
            <div className="f-ml">
              <div className="f-ml__wrap">
                <div className="f-ml__top">
                  <div className="f-ml__top-left">
                    <div className="f-ml__nav">
                      <div className="f-ml__nav-list">
                        <h3 className="f-ml__nav-heading">Bet9ja</h3>
                          <div className="f-ml__nav-item">
                            <a className="f-ml-link" href={links.home}>Home</a>
                          </div>

                          <div className="f-ml__nav-item">
                            <a className="f-ml-link" href={links.about_us}>About Us</a>
                          </div>

                          <div className="f-ml__nav-item">
                            <a className="f-ml-link" href={links.become_an_agent}>Become an Agent</a>
                          </div>

                          <div className="f-ml__nav-item">
                            <a className="f-ml-link" href={links.contact_us}>Contact us</a>
                          </div>

                          <div className="f-ml__nav-item">
                            <a className="f-ml-link" href={links.results}>Results</a>
                          </div>

                          <div className="f-ml__nav-item">
                            <a className="f-ml-link" href={links.web_affiliates}>Web Affiliates</a>
                          </div>

                      </div>
                      <div className="f-ml__nav-list">

                        <div className="f-ml__nav-item">
                          <a className="f-ml-link" href={links.terms_and_conditions}>Terms & Conditions</a>
                        </div>

                        <div className="f-ml__nav-item">
                          <a className="f-ml-link" href={links.responsible_gambling}>Responsible Gambling</a>
                        </div>

                        <div className="f-ml__nav-item">
                          <a className="f-ml-link" href={links.privacy}>Privacy</a>
                        </div>
                      </div>

                      <div className="f-ml__nav-compliance">
                        <a className="f-ml-link" target="_blank"
                           href={links.ndpb}></a>
                      </div>
                    </div>

                    <div className="f-ml__social">
                      <a href={links.instagram} className="f-ml__social-item instagrm" title="Instagram" />
                      <a href={links.facebook} className="f-ml__social-item fbook" title="Facebook" />
                      <a href={links.twitter} className="f-ml__social-item twittr" title="Twitter" />
                    </div>
                  </div>
                  <div className="f-ml__top-right" />
                </div>
                <div className="f-ml__bottom">
                  <div className="f-ml__info">
                    <div className="f-ml__info-left">
                      <div className="f-ml__payment">
                        <div className="f-ml__payment-img payment" />
                      </div>
                    </div>
                    <div className="f-ml__info-right">
                      <div className="f-ml__copy">
                        <div className="f-ml__copy-txt">© Bet9ja.com all rights reserved</div>
                        <span className="f-ml__copy-icon eighteen" />
                      </div>
                    </div>
                  </div>
                  <div className="f-ml__legal">
                    <p>
                      Bet9ja is not affiliated or connected with sports teams, event organisers and/or players
                      displayed on its images/websites.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );

}

export default Footer;
